import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Heading from "../components/individuals/Heading";
import { useSearchParams } from "react-router-dom";
import { useEffect, useRef } from "react";
import FadeInSection, {
  FadeInType,
} from "../components/wrappers/FadeInSection";
export default function Support() {
  const [searchParams] = useSearchParams();
  let join_subject_value =
    searchParams.get("subject") === "join" ? "I want to create a chapter" : "";
  let join_message_value =
    searchParams.get("subject") === "join"
      ? "Hello, I would like to create a chapter in my area. Can you please provide me with some more information?"
      : "";
  const refContainer = useRef(null);
  useEffect(() => {
    if (searchParams.get("subject") === "join") {
      refContainer.current.scrollIntoView({ behavior: "smooth" });
    }
  });
  return (
    <div className="w-full h-full">
      <Navbar />
      <section id="support" className="pt-14 sm:pt-20 lg:pt-[130px]">
        <div className="px-4 mx-auto w-5/6 xl:w-3/5 z-100 relative">
          <div className="-mx-4 flex flex-wrap justify-center">
            <div className="w-full px-4 xl:w-10/12">
              <FadeInSection distance={FadeInType.FADEONLY}>
                <Heading heading="Support" className="text-center" />
              </FadeInSection>
              <FadeInSection distance={FadeInType.SHORT}>
                <div className="flex flex-wrap items-center pb-14 lg:pb-0">
                  <div className="w-full px-4 lg:w-1/2">
                    <div className="relative mb-12 max-w-[500px] pt-6 md:mb-14 lg:pt-16">
                      <h2 className="mb-5 text-2xl font-semibold sm:text-4xl md:text-[40px] md:leading-[60px] dark:text-white">
                        Contact us by email
                      </h2>
                    </div>
                  </div>

                  <div className="w-full px-4 lg:w-1/2">
                    <div className="flex items-center">
                      <span className="bg-dark mr-10 h-1 w-full max-w-[200px] dark:bg-white"></span>
                      <a
                        href="mailto:stemenj1@gmail.com"
                        className="text-xl md:text-3xl lg:text-xl xl:text-3xl dark:text-white"
                      >
                        stemenj1@gmail.com
                      </a>
                    </div>
                  </div>
                </div>
              </FadeInSection>
              <FadeInSection distance={FadeInType.SHORT}>
                <div className="relative z-10 mb-8 flex items-center justify-center">
                  <span className="absolute top-1/2 left-0 -z-10 h-[1px] w-full -translate-y-1/2 bg-slate-300 block dark:bg-[#2E333D]"></span>
                  <p className="text-dark-text bg-white text-base font-medium px-4 dark:bg-background">
                    Or any of these other options
                  </p>
                </div>
                <div className="-mx-4 flex flex-wrap py-12">
                  <div className="w-full px-4 md:w-1/2 md:items-center md:justify-center flex">
                    <div className="mb-6">
                      <h3 className="mb-2 text-base sm:text-xl dark:text-white">
                        Phone Number
                      </h3>
                      <p className="text-dark-text text-base font-medium">
                        (973) 932-4185
                      </p>
                    </div>
                  </div>
                  <div className="w-full px-4 md:w-1/2 md:items-center md:justify-center flex">
                    <div
                      className="mb-6 flex items-center space-x-5 lg:justify-end"
                      ref={refContainer}
                    >
                      {/*the ref is here so that there isn't an overscroll*/}

                      {/* <a
                        href="https://facebook.com/61573552978398"
                        name="social-link"
                        aria-label="social-link"
                        className="text-dark-text hover:text-primary dark:hover:text-white"
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          className="fill-current"
                        >
                          <path d="M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47 14 5.5 16 5.5H17.5V2.14C17.174 2.097 15.943 2 14.643 2C11.928 2 10 3.657 10 6.7V9.5H7V13.5H10V22H14V13.5Z"></path>
                        </svg>
                      </a> */}
                      <a
                        href="https://instagram.com/stemenj_north"
                        name="social-link"
                        aria-label="social-link"
                        className="text-dark-text hover:text-primary dark:hover:text-white"
                      >
                        <svg
                          width="24"
                          height="24"
                          aria-hidden="true"
                          className="fill-current"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                            clip-rule="evenodd"
                          ></path>
                        </svg>
                      </a>
                      <a
                        href="https://instagram.com/stemenj_south"
                        name="social-link"
                        aria-label="social-link"
                        className="text-dark-text hover:text-primary dark:hover:text-white"
                      >
                        <svg
                          width="24"
                          height="24"
                          aria-hidden="true"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                            clip-rule="evenodd"
                          ></path>
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </FadeInSection>
            </div>
          </div>

          <FadeInSection distance={FadeInType.SHORT}>
            <div className="relative z-10 mb-8 flex items-center justify-center ">
              <span className="absolute top-1/2 left-0 -z-10 block h-[1px] w-full -translate-y-1/2 bg-slate-300 dark:bg-[#2E333D]"></span>
              <p className="text-dark-text bg-white text-base font-medium px-4 dark:bg-background">
                Or fill out the form below
              </p>
            </div>
            <div className="mx-auto max-w-[780px] py-12 ">
              <form
                method="POST"
                action="https://formsubmit.co/stemenj1@gmail.com"
              >
                <div className="-mx-4 flex flex-wrap z-10">
                  <div className="w-full px-4 sm:w-1/2">
                    <div className="mb-12">
                      <label
                        for="name"
                        className="mb-3 block text-base dark:text-white"
                      >
                        Your Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        id="name"
                        placeholder="Full Name"
                        required
                        className="placeholder-dark-text focus:border-primary w-full border-b bg-transparent py-5 text-base font-medium outline-hidden dark:border-[#2C3443] dark:text-white dark:focus:border-white"
                      />
                    </div>
                  </div>
                  <div className="w-full px-4 sm:w-1/2">
                    <div className="mb-12">
                      <label
                        for="email"
                        className="mb-3 block text-base dark:text-white"
                      >
                        Email Address
                      </label>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        required
                        placeholder="Email Address"
                        className="placeholder-dark-text focus:border-primary w-full border-b bg-transparent py-5 text-base font-medium outline-hidden dark:border-[#2C3443] dark:text-white dark:focus:border-white"
                      />
                    </div>
                  </div>
                  <div className="w-full px-4 sm:w-1/2">
                    <div className="mb-12">
                      <label
                        for="phone"
                        className="mb-3 block text-base dark:text-white"
                      >
                        Location
                      </label>
                      <input
                        type="text"
                        name="location"
                        id="location"
                        placeholder="Your City"
                        className="placeholder-dark-text focus:border-primary w-full border-b bg-transparent py-5 text-base font-medium outline-hidden dark:border-[#2C3443] dark:text-white dark:focus:border-white"
                      />
                    </div>
                  </div>
                  <div className="w-full px-4 sm:w-1/2">
                    <div className="mb-12">
                      <label
                        for="subject"
                        className="mb-3 block text-base dark:text-white"
                      >
                        Subject
                      </label>
                      <input
                        type="text"
                        name="subject"
                        id="subject"
                        required
                        placeholder="Type Subject"
                        defaultValue={join_subject_value}
                        className="placeholder-dark-text focus:border-primary w-full border-b bg-transparent py-5 text-base font-medium outline-hidden dark:border-[#2C3443] dark:text-white dark:focus:border-white"
                      />
                    </div>
                  </div>
                  <div className="w-full px-4">
                    <div className="mb-10">
                      <label
                        for="message"
                        className="mb-3 block text-base dark:text-white"
                      >
                        Message
                      </label>
                      <textarea
                        rows="4"
                        name="message"
                        id="message"
                        required
                        placeholder="Type Message"
                        defaultValue={join_message_value}
                        className="placeholder-dark-text focus:border-primary w-full resize-none border-b bg-transparent py-5 text-base font-medium outline-hidden dark:border-[#2C3443] dark:text-white dark:focus:border-white"
                      ></textarea>
                    </div>
                  </div>

                  <div className="w-full px-4">
                    <div className="mb-12">
                      <label
                        for="terms"
                        className="text-dark-text hover:text-primary flex cursor-pointer select-none"
                      >
                        <div className="relative">
                          <input
                            type="checkbox"
                            id="terms"
                            required
                            className="sr-only"
                          />
                          <div className="box mt-1 mr-4 flex h-5 w-5 items-center justify-center rounded-sm border dark:border-[#414652]">
                            <span className="opacity-0">
                              <svg
                                width="11"
                                height="8"
                                viewBox="0 0 11 8"
                                fill="none"
                                className="stroke-current"
                              >
                                <path
                                  d="M10.0915 0.951972L10.0867 0.946075L10.0813 0.940568C9.90076 0.753564 9.61034 0.753146 9.42927 0.939309L4.16201 6.22962L1.58507 3.63469C1.40401 3.44841 1.11351 3.44879 0.932892 3.63584C0.755703 3.81933 0.755703 4.10875 0.932892 4.29224L0.932878 4.29225L0.934851 4.29424L3.58046 6.95832C3.73676 7.11955 3.94983 7.2 4.1473 7.2C4.36196 7.2 4.55963 7.11773 4.71406 6.9584L10.0468 1.60234C10.2436 1.4199 10.2421 1.1339 10.0915 0.951972ZM4.2327 6.30081L4.2317 6.2998C4.23206 6.30015 4.23237 6.30049 4.23269 6.30082L4.2327 6.30081Z"
                                  stroke-width="0.4"
                                ></path>
                              </svg>
                            </span>
                          </div>
                        </div>
                        I have read the Terms of the Service &amp; I accept the
                        Privacy Policy
                      </label>
                    </div>
                  </div>

                  <div className="w-full px-4">
                    <button
                      type="submit"
                      className="cursor-pointer bg-primary hover:bg-primary/90 flex w-full items-center justify-center rounded-sm px-8 py-[14px] text-base text-white"
                    >
                      Send Message
                    </button>
                  </div>
                </div>
                <input
                  type="hidden"
                  name="_next"
                  value={window.location.origin + "/?form=true"}
                ></input>
                <input
                  type="hidden"
                  name="_subject"
                  value="Website Form Inquiry"
                ></input>
                <input type="text" name="_honey" className="hidden"></input>
              </form>
            </div>
          </FadeInSection>
        </div>
        <div className="absolute top-0 right-0 z-1">
          <svg
            width="1000"
            height="500"
            viewBox="0 0 1100 900"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.3" filter="url(#filter1)">
              <rect
                x="300"
                y="-3.65"
                width="629.62"
                height="757"
                transform="rotate(-40.44 463.78 -125.739)"
                fill="url(#grad1)"
              ></rect>
            </g>
            <defs>
              <filter
                id="filter1"
                x="0.0878906"
                y="-776.711"
                width="1726.24"
                height="1876.4"
                filterUnits="userSpaceOnUse"
              >
                <feFlood floodOpacity="0" result="BackgroundImage"></feFlood>
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImage"
                  result="shape"
                ></feBlend>
                <feGaussianBlur stdDeviation="225"></feGaussianBlur>
              </filter>
              <linearGradient
                id="grad1"
                x1="420.6"
                y1="60.5"
                x2="960.732"
                y2="623.2"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#ABBCFF"></stop>
                <stop offset="0.912" stopColor="#4A6CF7"></stop>
              </linearGradient>
            </defs>
          </svg>
        </div>
      </section>
      <Footer />
    </div>
  );
}
